<div class="card">
  <div class="card-body">
      <h5>{{name | translate }}</h5>
      <hr />
      <p>{{ description | translate }}</p>
  </div>
</div>
